module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-bg3.png?8ae98016";